module.exports = __webpack_public_path__ + "assets/img/Carbon Neutrality and Green Impact Report 2020.f4cd5ebf.png";